const Constant = {
    // BASE_URL: 'http://127.0.0.1:8000/api'
    // BASE_URL: 'https://api.sergiom175.sg-host.com/api'
    BASE_URL: 'https://surgery-api.dynamicflowdev.com'
}

export default Constant;